/**
 * Forced-2FA-setup screen.
 *
 * Reached only when the user's role falls under the org's
 * ``require_2fa`` policy AND they haven't set up 2FA yet. The
 * ProtectedRoute gate redirects every other authenticated path here
 * until ``must_setup_2fa`` flips to false.
 *
 * Visually distinct from /account/security so the user understands
 * this isn't an optional setting they can dismiss.
 */
import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";
import { Card } from "@/components/ui/Card";
import { TwoFactorCard } from "@/components/auth/TwoFactorCard";
import { pageTransition } from "@/lib/utils";

export function Setup2FAPage() {
  return (
    <motion.div
      {...pageTransition}
      className="min-h-screen bg-background flex items-center justify-center px-4 py-10"
    >
      <div className="w-full max-w-xl space-y-4">
        <Card className="border-warning/30 bg-warning/5">
          <div className="flex items-start gap-3">
            <ShieldAlert className="h-5 w-5 text-warning shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-semibold text-text-primary">
                Two-factor authentication required
              </h2>
              <p className="text-sm text-text-muted mt-1">
                Your organization requires every account in your role to
                use 2FA. Set it up below to continue. You won&rsquo;t be
                able to access the rest of the app until 2FA is active
                on your account.
              </p>
            </div>
          </div>
        </Card>

        <TwoFactorCard />
      </div>
    </motion.div>
  );
}

export default Setup2FAPage;
